/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Trouble_TitleInputs */

const en_wc_dl_trouble_title = /** @type {(inputs: Wc_Dl_Trouble_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troubleshooting`)
};

/**
* | output |
* | --- |
* | "Troubleshooting" |
*
* @param {Wc_Dl_Trouble_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_trouble_title = /** @type {((inputs?: Wc_Dl_Trouble_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Trouble_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_trouble_title(inputs)
});
export { wc_dl_trouble_title as "wc.dl.trouble_title" }